import { render, staticRenderFns } from "./CompensationSteps.vue?vue&type=template&id=10ad1519&scoped=true"
import script from "./CompensationSteps.vue?vue&type=script&lang=js"
export * from "./CompensationSteps.vue?vue&type=script&lang=js"
import style0 from "./CompensationSteps.vue?vue&type=style&index=0&id=10ad1519&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ad1519",
  null
  
)

export default component.exports